import { useQuery } from "react-query";
import { getStates } from "../../../../actions/CarrierAgreementMgmt/States";
let stateList = [];
export const useGetState = () => {
  return useQuery("States", getStates, {
    refetchOnWindowFocus: false,
  });
};
